module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-clockwise-6f94648f.svg";